module.exports = __webpack_public_path__ + "media/images/call-24px-214a9d31b621bb1c675255b02c1492db.svg";